/**
 * Other SVGs — category keys, templates, and UI labels.
 * Titles still match Shopify wording: "geburtsdaten" / "initials" in product name.
 */

/** Internal category keys (stable for templates and logic). */
export const OTHER_SVG_CATEGORY = {
  BIRTH_DATA: 'birth_data',
  INITIALS: 'initials',
}

/** Human-readable labels for chips and headings. */
export const OTHER_SVG_CATEGORY_LABEL = {
  [OTHER_SVG_CATEGORY.BIRTH_DATA]: 'Birth data',
  [OTHER_SVG_CATEGORY.INITIALS]: 'Initials',
}

export const OTHER_SVG_TEMPLATE_BY_CATEGORY = {
  [OTHER_SVG_CATEGORY.BIRTH_DATA]: 'svg/circle-text',
  [OTHER_SVG_CATEGORY.INITIALS]: 'initials',
}

/**
 * Birth-data fields: stable key, UI label, Shopify property name variants.
 * @typedef {{ key: string, label: string, propertyKeys?: string[] }} OtherSvgFieldDef
 * @type {OtherSvgFieldDef[]}
 */
export const OTHER_SVG_BIRTH_DATA_FIELDS = [
  { key: 'geburtsdatum', label: 'Geburtsdatum', propertyKeys: ['Geburtsdatum'] },
  { key: 'geburtszeit', label: 'Geburtszeit', propertyKeys: ['Geburtszeit'] },
  { key: 'geburtsgewicht', label: 'Geburtsgewicht', propertyKeys: ['Geburtsgewicht'] },
  {
    key: 'geburtsgroesse',
    label: 'Geburtsgrösse',
    propertyKeys: ['Geburtsgrösse', 'Geburtsgrosse', 'Geburtsgroesse', 'Geburtsgröße'],
  },
]

/** Initials fields (values prefilled from numbered "Initial" line-item properties). */
export const OTHER_SVG_INITIALS_FIELDS = [
  { key: 'initial_1', label: 'Initial' },
  { key: 'initial_2', label: 'Initial' },
  { key: 'initial_3', label: 'Initial' },
  { key: 'initial_4', label: 'Initial' },
]

export const OTHER_SVG_FIELDS_BY_CATEGORY = {
  [OTHER_SVG_CATEGORY.BIRTH_DATA]: OTHER_SVG_BIRTH_DATA_FIELDS,
  [OTHER_SVG_CATEGORY.INITIALS]: OTHER_SVG_INITIALS_FIELDS,
}

/** Birth-data line order for SVG API `data.lines`: zeit → grösse → gewicht → datum. */
export const OTHER_SVG_BIRTH_DATA_API_LINE_KEYS = [
  'geburtszeit',
  'geburtsgroesse',
  'geburtsgewicht',
  'geburtsdatum',
]

export const OTHER_SVG_LINE_KEYS_BY_CATEGORY = {
  [OTHER_SVG_CATEGORY.BIRTH_DATA]: OTHER_SVG_BIRTH_DATA_API_LINE_KEYS,
  [OTHER_SVG_CATEGORY.INITIALS]: OTHER_SVG_INITIALS_FIELDS.map((f) => f.key),
}

/** @deprecated use OTHER_SVG_BIRTH_DATA_FIELDS */
export const OTHER_SVG_BIRTH_DATA_PLACEHOLDERS = OTHER_SVG_BIRTH_DATA_FIELDS.map((f) => f.label)

/** @deprecated use OTHER_SVG_BIRTH_DATA_PLACEHOLDERS */
export const OTHER_SVG_GEBURTSDATEN_PLACEHOLDERS = OTHER_SVG_BIRTH_DATA_PLACEHOLDERS

/** @deprecated use OTHER_SVG_INITIALS_FIELDS */
export const OTHER_SVG_INITIALS_PLACEHOLDERS = OTHER_SVG_INITIALS_FIELDS.map((f) => f.label)
